import { MapOfLevelAdjacencies } from "src/api/level";

export const DemoLevelAdjacencies: MapOfLevelAdjacencies = {};
